<div
  [attr.layout-align-items-center]="centered && !stage ? '' : null"
  [attr.layout-align-items-start]="!centered ? '' : null"
  [class.hasStage]="stage"
  [rtTooltip]="offer?.title"
  [rtTooltipEnabled]="!!offer"
  [rtTooltipPosition]="'below'"
  layout-full-height
  layout-horizontal
>
  <ng-container *ngIf="tooltip">
    <rt-icon
      *ngIf="ratingKey"
      [name]="iconMap[ratingKey]"
      [rtTooltip]="getRatingTranslation(ratingKey)"
      [rtTooltipPosition]="'right'"
      [attr.green-icon]="colorize ? isGreen(ratingKey) : null"
      [attr.grey-icon]="colorize ? isGrey(ratingKey) : null"
      [size]="size"
    >
    </rt-icon>
  </ng-container>

  <ng-container *ngIf="!tooltip">
    <rt-icon
      *ngIf="ratingKey"
      [name]="iconMap[ratingKey]"
      [attr.grey-icon]="colorize ? isGrey(ratingKey) : null"
      [attr.green-icon]="colorize ? isGreen(ratingKey) : null"
      [size]="size"
    >
    </rt-icon>
  </ng-container>
  <div class="text-wrap">
    <div *ngIf="hasVariant('hasLabel')" class="rating">
      <rt-truncate>
        {{ getRatingTranslation(ratingKey) }}
      </rt-truncate>
    </div>
    <div *ngIf="stage" class="stage">
      <rt-truncate>
        <em>{{ stage }}</em>
      </rt-truncate>
    </div>
  </div>
</div>
